// StripeWrapper.jsx
import React from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import SubscriptionCheckout from "./SubscriptionCheckout";

// ✅ Remplace par ta clé publique Stripe test/live
const stripePromise = loadStripe("pk_test_51RlbgSQbvZpAvZcgAdIeWosO0cDLoUrv94ywqaktfcguqr0bRYsJs1Q2vDzLw3xIMBtCDhC8QfInWH8l4jkEHcCi00JbZUIBDh");

export default function StripeWrapper() {
    return (
        <Elements stripe={stripePromise}>
            <SubscriptionCheckout />
        </Elements>
    );
}
